import React from 'react'

import { useFeatureFlag } from 'hooks/useFeatureFlag'
import { useInlineReferenceValidationToggleStore } from 'stores/useInlineReferenceValidationToggleStore'
import { MessageReference } from 'types/Api'
import { cn } from 'utils/cn'

import { ReferenceIcon } from './ReferenceIcon'
import { ReferenceLabel } from './ReferenceLabel'
import { useInlineReferenceType } from './useInlineReferenceType'

type Props = {
  isActiveReference: boolean
  messageId: string
  onClick: (e: React.KeyboardEvent<HTMLButtonElement> | React.PointerEvent<HTMLButtonElement>) => void
  reference: MessageReference
  referenceNumber?: number
}

export const Tag = ({ isActiveReference, messageId, onClick, reference, referenceNumber }: Props) => {
  const hasSourceValidationFlag = useFeatureFlag('source_validation')

  const { inlineReferenceValidationType } = useInlineReferenceValidationToggleStore()

  const referenceWithType = useInlineReferenceType(messageId, reference)

  const showReferenceLabel = Boolean(hasSourceValidationFlag && inlineReferenceValidationType)

  const tooltipText = `${reference.metadata.title}${'citations' in reference.metadata ? ` - ${reference.metadata.citations.join(', ')}` : ''}`

  return (
    <button
      className={cn(
        'relative scroll-mt-[100px] inline-flex justify-center max-w-40 items-center no-underline font-medium text-xs rounded-full mx-1 [&+button]:ml-0 cursor-pointer group align-top',
        { 'border border-light hover:bg-light': showReferenceLabel },
        { '': !showReferenceLabel },
      )}
      onKeyDown={onClick}
      onPointerDown={onClick}
      type="button"
      title={tooltipText}
    >
      <span className={cn('flex  items-center font-medium text-xs overflow-hidden truncate', { 'pr-2 pl-6 h-[20px]': showReferenceLabel })}>
        <div className={cn('h-[22px] min-w-[22px] flex items-center justify-center text-default-on-bg-karnovnote bg-karnovnote group-hover:bg-karnovnote-tab-hover rounded-full ', {
          'bg-karnovnote-tab-hover': isActiveReference,
          '-left-px -top-px absolute': showReferenceLabel,
        })}
        >
          {referenceNumber}
        </div>
        {showReferenceLabel && <span className="mr-1"><ReferenceIcon referenceWithType={referenceWithType} /></span>}
        {showReferenceLabel && <ReferenceLabel metadata={reference.metadata} referenceType={referenceWithType.type} inlineReferenceValidationType={inlineReferenceValidationType} />}
      </span>
    </button>
  )
}
